import { render, staticRenderFns } from "./RsaDynamicBodyAreaComponents.vue?vue&type=template&id=909d5e78&scoped=true"
import script from "./RsaDynamicBodyAreaComponents.vue?vue&type=script&lang=js"
export * from "./RsaDynamicBodyAreaComponents.vue?vue&type=script&lang=js"
import style0 from "./RsaDynamicBodyAreaComponents.vue?vue&type=style&index=0&id=909d5e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909d5e78",
  null
  
)

export default component.exports